export * from './campaign-details-desktop'
